async function actualizarTelefono(telefono) {

    const BASE_URL = window.location.hostname === "localhost" 
        ? "http://localhost:4000" 
        : "https://vetladradoc.uy";

    try {  
        return await fetch(`${BASE_URL}/api/cliente/agregarTelefono`, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ telefono }),
            credentials: "include"
        });
    } catch (error) {
        console.error("Error al intentar agendar la consulta:", error);
        throw error;
    }
}

export default actualizarTelefono;